var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img_box"},[_c('img',{staticClass:"img2",attrs:{"src":require("../assets/images/beyond.jpg"),"alt":""}}),_c('img',{staticClass:"img1",attrs:{"src":require("../assets/images/music.png"),"alt":""}})])
}]

export { render, staticRenderFns }